/**
 * Parse Service Configuration
 * This module initializes and configures the Parse SDK for backend communication.
 * It sets up the necessary credentials and server URLs based on the environment.
 */

const Parse = require("parse");

// Initialize Parse with application credentials from environment variables
Parse.initialize(process.env.REACT_APP_APPID, process.env.REACT_APP_JAVASCRIPT_KEY);

// Set the Parse server URL based on the environment (development or production)
Parse.serverURL = process.env.NODE_ENV == "development"
     ? process.env.REACT_APP_SERVER_URL_DEV
     : process.env.REACT_APP_SERVER_URL_PROD;

export default Parse;
